import React, { FC } from "react";
import { Button, TButtonProps } from "kanopi-components/Button";
import { SIZE as BUTTON_SIZE } from "baseui/button";
import { useAPI } from "kw/api/useAPI";
import { toaster } from "kanopi-components/ToastContainer";
import { QuoteState } from "kw/api/zeus";

type TDismissRenewalButton = {
  renewalQuoteId: string;
  fetchPolicy?: (id: string) => void;
} & TButtonProps;

export const DismissRenewalButton: FC<TDismissRenewalButton> = ({
  renewalQuoteId,
  fetchPolicy,
  children,
  ...buttonProps
}) => {
  const { mutation } = useAPI();
  const discardRenewal = () => {
    mutation(
      {
        discardRenewalQuote: [
          {
            input: {
              renewalQuoteId: renewalQuoteId,
            },
          },
          {
            id: true,
            quote: {
              state: true,
            },
            policy: {
              id: true,
            },
          },
        ],
      },
      (response: {
        discardRenewalQuote: {
          policy: { id: string };
          quote: { state: QuoteState };
        };
      }) => {
        // An unsuccessful response will generate an error handled by the API hook
        if (response.discardRenewalQuote.quote.state === QuoteState.DISCARDED) {
          toaster({
            kind: "POSITIVE",
            content: "Policy renewal has been discarded.",
            key: "discard-renewal-quote-success-toast",
          });
          fetchPolicy(response.discardRenewalQuote.policy.id);
        }
      }
    );
  };

  return (
    <Button
      size={BUTTON_SIZE.compact}
      outlined={true}
      onClick={discardRenewal}
      data-testid="discardRenewalButton"
      {...buttonProps}
    >
      {children || "Discard Renewal"}
    </Button>
  );
};
